<template>
  <section class="fasilitas-containter" data-aos="fade-left" data-aos-delay="300">
    <div class="container">
      <div class="section-title text-center">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-uppercase mt-0 line-height-1">
              Fasilitas
              <span class="text-theme-colored">Rumah Sakit UII</span>
            </h2>
          </div>
        </div>
      </div>
      <div class="section-content mt-30 fasilitas-content-home">
        <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <div v-else-if="facilities.length < 1" class="col-md-12 alert alert-danger">No data</div>
        <carousel
          v-else
          :autoplay="true"
          :nav="false"
          :items="(facilities.length > 3) ? 3 : facilities.length"
          :loop="false"
          :dots="false"
          :responsive="{
					  	1024:{items:3},
					  	639:{items:2},
					  	0:{items:1}
					  }"
        >
          <div :key="'facility-' + item.id" v-for="item in facilities" class="col-md-12">
            <div class="bg-uii facility-item">
              <div class="facility-item-img">
                <img
                  v-bind:src="(JSON.parse(item.meta).meta_picture == null) ? 'http://placehold.it/200x200' : JSON.parse(item.meta).meta_picture"
                  alt
                  class="img-responsive"
                />
              </div>
              <h3 class="mt-5 mb-15 p-10">
                <a href="#">{{item.title}}</a>
              </h3>
              <p class>{{ item.content }}</p>
            </div>
          </div>
        </carousel>
      </div>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
import api from "../../services/api";

export default {
  components: { carousel },
  data() {
    return {
      show_loading: true,
      facilities: [],
    };
  },
  mounted() {
    this.getFacilities();
  },
  methods: {
    getFacilities() {
      api
        .post(api.route.get.facility)
        .then((res) => {
          let status = res.status;
          if (status) {
            this.show_loading = false;
            this.facilities = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
};
</script>
<style>
.facility-item {
  border-radius: 5px;
  height: 250px;
}
.facility-item-img {
  max-height: 200px;
  overflow: hidden;
}
.facility-item-img img {
  border-radius: 5px 5px 0px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/HomeFasilitas.vue